export enum TerminationReason {
	GuestAccount = 1,
	DuplicateAccount = 2,
	Other = 3, 
}

export class AccountStatusPeriod {
	status: string;
	startDate: Date;
	endDate?: Date;
	duration: string;
}

export class AccountStatusDeactivationPeriod extends AccountStatusPeriod {
	terminationMethod: string;
	terminationReason: string;
	terminationNotes: string;
	reasons?: string[];
	comments: string;
	billingEndDate: Date;
}

export enum TerminationMethod {
    User = 1,
    Technical = 2,
}